"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormField =
/*#__PURE__*/
function (_Component) {
  _inherits(FormField, _Component);

  function FormField(props) {
    var _this;

    _classCallCheck(this, FormField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      isValid: true,
      validationErrors: [],
      isPristine: true,
      required: false,
      defaultValue: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      var _this$props = _this.props,
          standAlone = _this$props.standAlone,
          unregisterField = _this$props.unregisterField;
      if (!standAlone) unregisterField(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "validateRequired", function (value) {
      switch (true) {
        case (0, _lodash.isBoolean)(value):
          return true;

        case (0, _lodash.isNumber)(value):
          return true;

        case (0, _lodash.isString)(value):
          return value.length > 0;

        case (0, _lodash.isObjectLike)(value):
          return !(0, _lodash.isEmpty)(value);

        default:
          return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function () {
      var _this$props2 = _this.props,
          validator = _this$props2.validation,
          required = _this$props2.required,
          validated = _this$props2.validated;
      var value = _this.state.value;
      var isValid = true;
      var validationErrors = [];

      var hasValue = _this.validateRequired(value);

      if (required && !hasValue) {
        isValid = false;
        validationErrors.push('Required');
      } else if (hasValue) {
        if (typeof validator === 'function') {
          isValid = validator(value);
          if (!isValid) validationErrors.push('Invalid');
        } else if (_typeof(validator) === 'object') {
          Object.keys(validator).forEach(function (validation) {
            if (!validator[validation](value)) {
              isValid = false;
              validationErrors.push(validation);
            }
          });
        }
      }

      _this.setState({
        isValid: isValid,
        validationErrors: validationErrors
      }, function () {
        return validated(_assertThisInitialized(_this), isValid);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setInitialValue", function (value) {
      _this.baseSetValue(value);

      _this.setState({
        isPristine: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setValue", function (value) {
      _this.baseSetValue(value);

      _this.setState({
        isPristine: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPristine", function (isPristine) {
      _this.setState({
        isPristine: isPristine
      });
    });

    _defineProperty(_assertThisInitialized(_this), "baseSetValue", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function () {
      return _this.state.value;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props3 = _this.props,
          fieldComponent = _this$props3.fieldComponent,
          registerField = _this$props3.registerField,
          unregisterField = _this$props3.unregisterField,
          validation = _this$props3.validation,
          validated = _this$props3.validated,
          valueChanged = _this$props3.valueChanged,
          fieldRef = _this$props3.fieldRef,
          defaultValue = _this$props3.defaultValue,
          rest = _objectWithoutProperties(_this$props3, ["fieldComponent", "registerField", "unregisterField", "validation", "validated", "valueChanged", "fieldRef", "defaultValue"]);

      var _this$state = _this.state,
          isPristine = _this$state.isPristine,
          isValid = _this$state.isValid,
          validationErrors = _this$state.validationErrors;
      return _react.default.createElement(fieldComponent, _objectSpread({
        setValue: _this.setValue,
        value: _this.getValue(),
        ref: fieldRef,
        isValid: isValid,
        validationErrors: validationErrors,
        isPristine: isPristine
      }, rest));
    });

    var _this$props4 = _this.props,
        _standAlone = _this$props4.standAlone,
        registerField = _this$props4.registerField;
    if (!_standAlone) _this.id = registerField(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FormField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          validation = _this$props5.validation,
          required = _this$props5.required;
      var defaultValue = this.state.defaultValue;
      if (defaultValue !== null) this.setInitialValue(defaultValue);
      if (validation || required) this.validate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props6 = this.props,
          validation = _this$props6.validation,
          valueChanged = _this$props6.valueChanged;
      var _this$state2 = this.state,
          defaultValue = _this$state2.defaultValue,
          required = _this$state2.required,
          value = _this$state2.value;
      if (!(0, _lodash.isEqual)(prevState.defaultValue, defaultValue)) this.setInitialValue(defaultValue);
      if (prevState.required !== required) this.validate();

      if (value !== prevState.value) {
        if (validation || required) {
          this.validate();
        } else {
          valueChanged(this);
        }
      }
    }
  }]);

  return FormField;
}(_react.Component);

_defineProperty(FormField, "propTypes", {
  required: _propTypes.default.bool,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.array, _propTypes.default.bool]),
  standAlone: _propTypes.default.bool,
  registerField: _propTypes.default.func.isRequired,
  validation: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.bool]),
  valueChanged: _propTypes.default.func,
  validated: _propTypes.default.func
});

_defineProperty(FormField, "defaultProps", {
  required: false,
  defaultValue: null,
  standAlone: false,
  validation: false,
  validated: function validated() {},
  valueChanged: function valueChanged() {}
});

_defineProperty(FormField, "getDerivedStateFromProps", function (props) {
  return {
    required: props.required,
    defaultValue: props.defaultValue
  };
});

var _default = function _default(fieldComponent) {
  return function (props) {
    return _react.default.createElement(_Context.default.Consumer, null, function (context) {
      return _react.default.createElement(FormField, _extends({}, props, context, {
        fieldComponent: fieldComponent
      }));
    });
  };
};

exports.default = _default;